import { useSyncExternalStore } from 'react';

/** Pantallas de transmisión (Ajustes): presentación, tarjetas del bateador/lanzador y momentos. */
const KEY = 'sportsarena.broadcast';
let on = (() => {
  try {
    if (typeof window === 'undefined') return true;
    // Pruebas automáticas: apagadas salvo que se pidan (como el tutorial), para no tapar clics.
    if (navigator.webdriver) return localStorage.getItem(KEY) === '1';
    return localStorage.getItem(KEY) !== '0';
  } catch {
    return true;
  }
})();
const listeners = new Set<() => void>();
export const getBroadcast = (): boolean => on;
export const setBroadcast = (v: boolean): void => {
  on = v;
  try {
    localStorage.setItem(KEY, v ? '1' : '0');
  } catch {
    /* sin almacenamiento */
  }
  listeners.forEach((l) => l());
};
export const useBroadcast = (): boolean =>
  useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    getBroadcast,
    getBroadcast
  );
